import { useQuery } from '@tanstack/react-query'
import Api from '../../../api.js'

export const useKomunikatPowitalny = (enabled = true) => {
    return useQuery({
        queryKey: ['komunikat-powitalny'],
        queryFn: async () => (await Api('/komunikat-powitalny'))?.data?.item,
        enabled,
    })
}
